// import React, { useState, useEffect } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import { Form, Button, Card, Row, Col, Alert, Spinner } from "react-bootstrap";
// import { membershipAPI } from "../../api/membershipPlans";
// import { gymMembersAPI } from "../../api/gymMembers";
// import Swal from "sweetalert2";
// import DatePicker from "react-datepicker";
// import {
//   FaUser,
//   FaCalendar,
//   FaDollarSign,
//   FaArrowLeft,
//   FaSave,
// } from "react-icons/fa";

// const EditPlan = () => {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const [loading, setLoading] = useState(true);
//   const [saving, setSaving] = useState(false);
//   const [error, setError] = useState("");
//   const [plan, setPlan] = useState(null);
//   const [members, setMembers] = useState([]);

//   const [subscriptionTypes] = useState([
//     { id: 1, name: "Basic" },
//     { id: 2, name: "Premium" },
//     { id: 3, name: "Gold" },
//   ]);

//   const [subscriptionPeriods] = useState([
//     { id: 1, months: 1, name: "1 Month" },
//     { id: 2, months: 3, name: "3 Months" },
//     { id: 3, months: 6, name: "6 Months" },
//     { id: 4, months: 12, name: "12 Months" },
//   ]);

//   const [formData, setFormData] = useState({
//     member: "",
//     subscription_type: "",
//     subscription_period: "",
//     batch: "morning",
//     plan_start_date: new Date(),
//     registration_fee: "",
//     amount: "",
//     paid_amount: "0",
//     notes: "",
//     is_active: true,
//   });

//   useEffect(() => {
//     fetchData();
//   }, [id]);

//   const fetchData = async () => {
//     try {
//       const [planResponse, membersResponse] = await Promise.all([
//         membershipAPI.getPlanById(id),
//         gymMembersAPI.getMembers(),
//       ]);

//       setPlan(planResponse.data.data || planResponse.data);
//       setMembers(membersResponse.data.data || membersResponse.data);

//       const planData = planResponse.data.data || planResponse.data;

//       setFormData({
//         member: planData.member?.toString() || "",
//         subscription_type: planData.subscription_type?.toString() || "",
//         subscription_period: planData.subscription_period?.toString() || "",
//         batch: planData.batch || "morning",
//         plan_start_date: planData.plan_start_date
//           ? new Date(planData.plan_start_date)
//           : new Date(),
//         registration_fee: planData.registration_fee?.toString() || "0",
//         amount: planData.amount?.toString() || "",
//         paid_amount: planData.paid_amount?.toString() || "0",
//         notes: planData.notes || "",
//         is_active: planData.is_active,
//       });
//     } catch (error) {
//       console.error("Error fetching data:", error);
//       Swal.fire({
//         icon: "error",
//         title: "Error",
//         text: "Failed to load plan details",
//       });
//       navigate("/membership/plans");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({
//       ...formData,
//       [name]: value,
//     });
//   };

//   const handleDateChange = (date) => {
//     setFormData({
//       ...formData,
//       plan_start_date: date,
//     });
//   };

//   const validateForm = () => {
//     const errors = [];

//     if (!formData.member) errors.push("Please select a member");
//     if (!formData.subscription_type)
//       errors.push("Please select subscription type");
//     if (!formData.subscription_period)
//       errors.push("Please select subscription period");
//     if (!formData.plan_start_date) errors.push("Please select start date");
//     if (!formData.amount || formData.amount <= 0)
//       errors.push("Please enter valid amount");
//     if (
//       parseFloat(formData.paid_amount) >
//       parseFloat(formData.amount) + parseFloat(formData.registration_fee)
//     ) {
//       errors.push("Paid amount cannot exceed total amount");
//     }

//     return errors;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     const errors = validateForm();
//     if (errors.length > 0) {
//       Swal.fire({
//         icon: "error",
//         title: "Validation Error",
//         html: errors.map((err) => `<p>• ${err}</p>`).join(""),
//       });
//       return;
//     }

//     setSaving(true);
//     setError("");

//     try {
//       const planData = {
//         member: parseInt(formData.member),
//         subscription_type: parseInt(formData.subscription_type),
//         subscription_period: parseInt(formData.subscription_period),
//         batch: formData.batch,
//         plan_start_date: formData.plan_start_date.toISOString().split("T")[0],
//         registration_fee: parseFloat(formData.registration_fee) || 0,
//         amount: parseFloat(formData.amount),
//         paid_amount: parseFloat(formData.paid_amount) || 0,
//         notes: formData.notes,
//         is_active: formData.is_active,
//       };

//       await membershipAPI.updatePlan(id, planData);

//       Swal.fire({
//         icon: "success",
//         title: "Updated!",
//         text: "Membership plan has been updated successfully.",
//         timer: 1500,
//         showConfirmButton: false,
//       });

//       setTimeout(() => {
//         navigate("/membership/plans");
//       }, 1500);
//     } catch (error) {
//       console.error("Error updating plan:", error);
//       setError(
//         error.response?.data?.message || "Failed to update membership plan"
//       );
//       Swal.fire({
//         icon: "error",
//         title: "Error",
//         text:
//           error.response?.data?.message || "Failed to update membership plan",
//       });
//     } finally {
//       setSaving(false);
//     }
//   };

//   const getMemberName = (memberId) => {
//     const member = members.find((m) => m.id === parseInt(memberId));
//     return member
//       ? `${member.first_name} ${member.last_name} (${member.member_id})`
//       : "Select Member";
//   };

//   const calculateTotal = () => {
//     const registrationFee = parseFloat(formData.registration_fee) || 0;
//     const amount = parseFloat(formData.amount) || 0;
//     return registrationFee + amount;
//   };

//   const calculatePending = () => {
//     const total = calculateTotal();
//     const paidAmount = parseFloat(formData.paid_amount) || 0;
//     return total - paidAmount;
//   };

//   if (loading) {
//     return (
//       <div className="text-center py-5">
//         <Spinner animation="border" variant="primary" />
//         <p className="mt-2">Loading plan details...</p>
//       </div>
//     );
//   }

//   if (!plan) {
//     return (
//       <Alert variant="danger">
//         Plan not found.{" "}
//         <Button variant="link" onClick={() => navigate("/membership/plans")}>
//           Go back
//         </Button>
//       </Alert>
//     );
//   }

//   return (
//     <div className="edit-plan-page">
//       <div className="page-header mb-4">
//         <Button
//           variant="outline-secondary"
//           onClick={() => navigate("/membership/plans")}
//           className="me-3"
//         >
//           <FaArrowLeft /> Back to Plans
//         </Button>
//         <h2 className="mb-0">Edit Membership Plan</h2>
//         <p className="text-muted mb-0">Plan ID: {plan.id}</p>
//       </div>

//       {error && (
//         <Alert variant="danger" onClose={() => setError("")} dismissible>
//           {error}
//         </Alert>
//       )}

//       <Row>
//         <Col lg={8}>
//           <Card className="mb-4">
//             <Card.Header className="bg-primary text-white">
//               <h5 className="mb-0">Plan Details</h5>
//             </Card.Header>
//             <Card.Body>
//               <Form onSubmit={handleSubmit}>
//                 <Row>
//                   <Col md={6}>
//                     <Form.Group className="mb-3">
//                       <Form.Label>Select Member *</Form.Label>
//                       <Form.Select
//                         name="member"
//                         value={formData.member}
//                         onChange={handleChange}
//                         required
//                       >
//                         <option value="">Select Member</option>
//                         {members.map((member) => (
//                           <option key={member.id} value={member.id}>
//                             {member.first_name} {member.last_name} (
//                             {member.member_id})
//                           </option>
//                         ))}
//                       </Form.Select>
//                     </Form.Group>
//                   </Col>

//                   <Col md={6}>
//                     <Form.Group className="mb-3">
//                       <Form.Label>Subscription Type *</Form.Label>
//                       <Form.Select
//                         name="subscription_type"
//                         value={formData.subscription_type}
//                         onChange={handleChange}
//                         required
//                       >
//                         <option value="">Select Type</option>
//                         {subscriptionTypes.map((type) => (
//                           <option key={type.id} value={type.id}>
//                             {type.name}
//                           </option>
//                         ))}
//                       </Form.Select>
//                     </Form.Group>
//                   </Col>
//                 </Row>

//                 <Row>
//                   <Col md={6}>
//                     <Form.Group className="mb-3">
//                       <Form.Label>Subscription Period *</Form.Label>
//                       <Form.Select
//                         name="subscription_period"
//                         value={formData.subscription_period}
//                         onChange={handleChange}
//                         required
//                       >
//                         <option value="">Select Period</option>
//                         {subscriptionPeriods.map((period) => (
//                           <option key={period.id} value={period.id}>
//                             {period.name}
//                           </option>
//                         ))}
//                       </Form.Select>
//                     </Form.Group>
//                   </Col>

//                   <Col md={6}>
//                     <Form.Group className="mb-3">
//                       <Form.Label>Batch *</Form.Label>
//                       <Form.Select
//                         name="batch"
//                         value={formData.batch}
//                         onChange={handleChange}
//                         required
//                       >
//                         <option value="morning">Morning</option>
//                         <option value="evening">Evening</option>
//                         <option value="full_day">Full Day</option>
//                       </Form.Select>
//                     </Form.Group>
//                   </Col>
//                 </Row>

//                 <Row>
//                   <Col md={6}>
//                     <Form.Group className="mb-3">
//                       <Form.Label>Plan Start Date *</Form.Label>
//                       <DatePicker
//                         selected={formData.plan_start_date}
//                         onChange={handleDateChange}
//                         dateFormat="yyyy-MM-dd"
//                         className="form-control"
//                         placeholderText="Select start date"
//                       />
//                     </Form.Group>
//                   </Col>

//                   <Col md={6}>
//                     <Form.Group className="mb-3">
//                       <Form.Label>Registration Fee (₹)</Form.Label>
//                       <div className="input-group">
//                         <span className="input-group-text">
//                           <FaDollarSign />
//                         </span>
//                         <Form.Control
//                           type="number"
//                           name="registration_fee"
//                           value={formData.registration_fee}
//                           onChange={handleChange}
//                           placeholder="500"
//                           min="0"
//                           step="0.01"
//                         />
//                       </div>
//                     </Form.Group>
//                   </Col>
//                 </Row>

//                 <Row>
//                   <Col md={6}>
//                     <Form.Group className="mb-3">
//                       <Form.Label>Total Amount (₹) *</Form.Label>
//                       <div className="input-group">
//                         <span className="input-group-text">
//                           <FaDollarSign />
//                         </span>
//                         <Form.Control
//                           type="number"
//                           name="amount"
//                           value={formData.amount}
//                           onChange={handleChange}
//                           placeholder="3000"
//                           min="1"
//                           step="0.01"
//                           required
//                         />
//                       </div>
//                     </Form.Group>
//                   </Col>

//                   <Col md={6}>
//                     <Form.Group className="mb-3">
//                       <Form.Label>Paid Amount (₹)</Form.Label>
//                       <div className="input-group">
//                         <span className="input-group-text">
//                           <FaDollarSign />
//                         </span>
//                         <Form.Control
//                           type="number"
//                           name="paid_amount"
//                           value={formData.paid_amount}
//                           onChange={handleChange}
//                           placeholder="0"
//                           min="0"
//                           step="0.01"
//                         />
//                       </div>
//                       <Form.Text className="text-muted">
//                         Amount already paid by the member
//                       </Form.Text>
//                     </Form.Group>
//                   </Col>
//                 </Row>

//                 <Row>
//                   <Col md={6}>
//                     <Form.Group className="mb-3">
//                       <Form.Label>Plan Status</Form.Label>
//                       <Form.Select
//                         name="is_active"
//                         value={formData.is_active}
//                         onChange={(e) =>
//                           setFormData({
//                             ...formData,
//                             is_active: e.target.value === "true",
//                           })
//                         }
//                       >
//                         <option value={true}>Active</option>
//                         <option value={false}>Inactive</option>
//                       </Form.Select>
//                     </Form.Group>
//                   </Col>
//                 </Row>

//                 <Form.Group className="mb-4">
//                   <Form.Label>Notes (Optional)</Form.Label>
//                   <Form.Control
//                     as="textarea"
//                     rows={3}
//                     name="notes"
//                     value={formData.notes}
//                     onChange={handleChange}
//                     placeholder="Any additional notes or terms..."
//                   />
//                 </Form.Group>

//                 <div className="text-center">
//                   <Button
//                     variant="primary"
//                     type="submit"
//                     disabled={saving}
//                     className="me-3 px-4"
//                   >
//                     <FaSave className="me-2" />
//                     {saving ? "Updating..." : "Update Plan"}
//                   </Button>
//                   <Button
//                     variant="outline-secondary"
//                     onClick={() => navigate("/membership/plans")}
//                   >
//                     Cancel
//                   </Button>
//                 </div>
//               </Form>
//             </Card.Body>
//           </Card>
//         </Col>

//         <Col lg={4}>
//           <Card className="mb-4">
//             <Card.Header className="bg-info text-white">
//               <h5 className="mb-0">Plan Summary</h5>
//             </Card.Header>
//             <Card.Body>
//               <div className="plan-summary">
//                 {formData.member && (
//                   <div className="mb-3">
//                     <h6>Selected Member:</h6>
//                     <p className="fw-bold">{getMemberName(formData.member)}</p>
//                   </div>
//                 )}

//                 {formData.subscription_type && (
//                   <div className="mb-3">
//                     <h6>Subscription Type:</h6>
//                     <p className="fw-bold">
//                       {subscriptionTypes.find(
//                         (t) => t.id === parseInt(formData.subscription_type)
//                       )?.name || "N/A"}
//                     </p>
//                   </div>
//                 )}

//                 {formData.subscription_period && (
//                   <div className="mb-3">
//                     <h6>Duration:</h6>
//                     <p className="fw-bold">
//                       {subscriptionPeriods.find(
//                         (p) => p.id === parseInt(formData.subscription_period)
//                       )?.name || "N/A"}
//                     </p>
//                   </div>
//                 )}

//                 <div className="mb-3">
//                   <h6>Batch:</h6>
//                   <p className="fw-bold">
//                     {formData.batch
//                       ? formData.batch.charAt(0).toUpperCase() +
//                         formData.batch.slice(1)
//                       : "Not set"}
//                   </p>
//                 </div>

//                 <div className="mb-3">
//                   <h6>Start Date:</h6>
//                   <p className="fw-bold">
//                     {formData.plan_start_date
//                       ? formData.plan_start_date.toLocaleDateString()
//                       : "Not set"}
//                   </p>
//                 </div>

//                 {plan.expiry_date && (
//                   <div className="mb-3">
//                     <h6>Expiry Date:</h6>
//                     <p className="fw-bold">
//                       {new Date(plan.expiry_date).toLocaleDateString()}
//                     </p>
//                   </div>
//                 )}
//               </div>
//             </Card.Body>
//           </Card>

//           <Card>
//             <Card.Header className="bg-success text-white">
//               <h5 className="mb-0">Payment Summary</h5>
//             </Card.Header>
//             <Card.Body>
//               <div className="payment-summary">
//                 <table className="table table-sm">
//                   <tbody>
//                     <tr>
//                       <td>Registration Fee:</td>
//                       <td className="text-end">
//                         ₹{formData.registration_fee || "0"}
//                       </td>
//                     </tr>
//                     <tr>
//                       <td>Plan Amount:</td>
//                       <td className="text-end">₹{formData.amount || "0"}</td>
//                     </tr>
//                     <tr className="table-active fw-bold">
//                       <td>Total Amount:</td>
//                       <td className="text-end">
//                         ₹{calculateTotal().toFixed(2)}
//                       </td>
//                     </tr>
//                     <tr>
//                       <td>Paid Amount:</td>
//                       <td className="text-end text-success">
//                         ₹{formData.paid_amount || "0"}
//                       </td>
//                     </tr>
//                     <tr className="table-warning fw-bold">
//                       <td>Pending Amount:</td>
//                       <td className="text-end text-danger">
//                         ₹{calculatePending().toFixed(2)}
//                       </td>
//                     </tr>
//                     <tr>
//                       <td>Fee Status:</td>
//                       <td className="text-end">
//                         <span
//                           className={`badge ${
//                             calculatePending() > 0 ? "bg-warning" : "bg-success"
//                           }`}
//                         >
//                           {calculatePending() > 0 ? "Pending" : "Paid"}
//                         </span>
//                       </td>
//                     </tr>
//                   </tbody>
//                 </table>
//               </div>
//             </Card.Body>
//           </Card>
//         </Col>
//       </Row>
//     </div>
//   );
// };

// export default EditPlan;

import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Form, Button, Card, Row, Col, Alert, Spinner } from "react-bootstrap";
import { membershipAPI } from "../../api/membershipPlans";
import { gymMembersAPI } from "../../api/gymMembers";
import { subscriptionAPI } from "../../api/subscription";
import Swal from "sweetalert2";
import DatePicker from "react-datepicker";
import {
  FaUser,
  FaCalendar,
  FaDollarSign,
  FaArrowLeft,
  FaSave,
} from "react-icons/fa";

const EditPlan = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [plan, setPlan] = useState(null);
  const [members, setMembers] = useState([]);
  const [subscriptionTypes, setSubscriptionTypes] = useState([]);
  const [subscriptionPeriods, setSubscriptionPeriods] = useState([]);

  const [formData, setFormData] = useState({
    member: "",
    subscription_type: "",
    subscription_period: "",
    batch: "morning",
    plan_start_date: new Date(),
    registration_fee: "",
    amount: "",
    paid_amount: "0",
    notes: "",
    is_active: true,
  });

  useEffect(() => {
    if (id) {
      fetchData();
    } else {
      Swal.fire({
        icon: "error",
        title: "Invalid Plan ID",
        text: "No plan ID provided. Redirecting to plans list.",
      });
      navigate("/membership/plans");
    }
  }, [id, navigate]);

  const fetchData = async () => {
    try {
      const [planResponse, membersResponse, typesResponse, periodsResponse] =
        await Promise.all([
          membershipAPI.getPlanById(id),
          gymMembersAPI.getMembers(),
          subscriptionAPI.getSubscriptionTypes(),
          subscriptionAPI.getSubscriptionPeriods(),
        ]);

      const planData = planResponse.data || planResponse;
      const memberData =
        membersResponse.data?.data || membersResponse.data || [];
      const typesData = typesResponse.data || [];
      const periodsData = periodsResponse.data || [];

      setPlan(planData);
      setMembers(memberData);
      setSubscriptionTypes(typesData);
      setSubscriptionPeriods(periodsData);

      setFormData({
        member: planData.member?.toString() || "",
        subscription_type: planData.subscription_type?.toString() || "",
        subscription_period: planData.subscription_period?.toString() || "",
        batch: planData.batch || "morning",
        plan_start_date: planData.plan_start_date
          ? new Date(planData.plan_start_date)
          : new Date(),
        registration_fee: planData.registration_fee?.toString() || "0",
        amount: planData.amount?.toString() || "",
        paid_amount: planData.paid_amount?.toString() || "0",
        notes: planData.notes || "",
        is_active: planData.is_active,
      });
    } catch (error) {
      console.error("Error fetching data:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to load plan details",
      });
      navigate("/membership/plans");
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleDateChange = (date) => {
    setFormData({
      ...formData,
      plan_start_date: date,
    });
  };

  const validateForm = () => {
    const errors = [];

    if (!formData.member) errors.push("Please select a member");
    if (!formData.subscription_type)
      errors.push("Please select subscription type");
    if (!formData.subscription_period)
      errors.push("Please select subscription period");
    if (!formData.plan_start_date) errors.push("Please select start date");
    if (!formData.amount || formData.amount <= 0)
      errors.push("Please enter valid amount");
    if (
      parseFloat(formData.paid_amount) >
      parseFloat(formData.amount) + parseFloat(formData.registration_fee)
    ) {
      errors.push("Paid amount cannot exceed total amount");
    }

    return errors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const errors = validateForm();
    if (errors.length > 0) {
      Swal.fire({
        icon: "error",
        title: "Validation Error",
        html: errors.map((err) => `<p>• ${err}</p>`).join(""),
      });
      return;
    }

    setSaving(true);
    setError("");

    try {
      const planData = {
        member: parseInt(formData.member),
        subscription_type: parseInt(formData.subscription_type),
        subscription_period: parseInt(formData.subscription_period),
        batch: formData.batch,
        plan_start_date: formData.plan_start_date.toISOString().split("T")[0],
        registration_fee: parseFloat(formData.registration_fee) || 0,
        amount: parseFloat(formData.amount),
        paid_amount: parseFloat(formData.paid_amount) || 0,
        notes: formData.notes,
        is_active: formData.is_active,
      };

      await membershipAPI.updatePlan(id, planData);

      Swal.fire({
        icon: "success",
        title: "Updated!",
        text: "Membership plan has been updated successfully.",
        timer: 1500,
        showConfirmButton: false,
      });

      setTimeout(() => {
        navigate("/membership/plans");
      }, 1500);
    } catch (error) {
      console.error("Error updating plan:", error);
      setError(
        error.response?.data?.message || "Failed to update membership plan"
      );
      Swal.fire({
        icon: "error",
        title: "Error",
        text:
          error.response?.data?.message || "Failed to update membership plan",
      });
    } finally {
      setSaving(false);
    }
  };

  const getMemberName = (memberId) => {
    const member = members.find((m) => m.id === parseInt(memberId));
    return member
      ? `${member.first_name} ${member.last_name} (${member.member_id})`
      : "Select Member";
  };

  const getSubscriptionTypeName = (typeId) => {
    const type = subscriptionTypes.find((t) => t.id === parseInt(typeId));
    return type ? type.name : "Select Type";
  };

  const getSubscriptionPeriodName = (periodId) => {
    const period = subscriptionPeriods.find((p) => p.id === parseInt(periodId));
    return period
      ? `${period.months} Month${period.months !== 1 ? "s" : ""}`
      : "Select Period";
  };

  const calculateTotal = () => {
    const registrationFee = parseFloat(formData.registration_fee) || 0;
    const amount = parseFloat(formData.amount) || 0;
    return registrationFee + amount;
  };

  const calculatePending = () => {
    const total = calculateTotal();
    const paidAmount = parseFloat(formData.paid_amount) || 0;
    return total - paidAmount;
  };

  if (loading) {
    return (
      <div className="text-center py-5">
        <Spinner animation="border" variant="primary" />
        <p className="mt-2">Loading plan details...</p>
      </div>
    );
  }

  if (!plan) {
    return (
      <Alert variant="danger">
        Plan not found.{" "}
        <Button variant="link" onClick={() => navigate("/membership/plans")}>
          Go back
        </Button>
      </Alert>
    );
  }

  return (
    <div className="edit-plan-page">
      <div className="page-header mb-4">
        <Button
          variant="outline-secondary"
          onClick={() => navigate("/membership/plans")}
          className="me-3"
        >
          <FaArrowLeft /> Back to Plans
        </Button>
        <h2 className="mb-0">Edit Membership Plan</h2>
        <p className="text-muted mb-0">Plan ID: {plan.id}</p>
      </div>

      {error && (
        <Alert variant="danger" onClose={() => setError("")} dismissible>
          {error}
        </Alert>
      )}

      <Row>
        <Col lg={8}>
          <Card className="mb-4">
            <Card.Header className="bg-primary text-white">
              <h5 className="mb-0">Plan Details</h5>
            </Card.Header>
            <Card.Body>
              <Form onSubmit={handleSubmit}>
                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Select Member *</Form.Label>
                      <Form.Select
                        name="member"
                        value={formData.member}
                        onChange={handleChange}
                        required
                      >
                        <option value="">Select Member</option>
                        {members.map((member) => (
                          <option key={member.id} value={member.id}>
                            {member.first_name} {member.last_name} (
                            {member.member_id})
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Subscription Type *</Form.Label>
                      <Form.Select
                        name="subscription_type"
                        value={formData.subscription_type}
                        onChange={handleChange}
                        required
                      >
                        <option value="">Select Type</option>
                        {subscriptionTypes.map((type) => (
                          <option key={type.id} value={type.id}>
                            {type.name}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Subscription Period *</Form.Label>
                      <Form.Select
                        name="subscription_period"
                        value={formData.subscription_period}
                        onChange={handleChange}
                        required
                      >
                        <option value="">Select Period</option>
                        {subscriptionPeriods.map((period) => (
                          <option key={period.id} value={period.id}>
                            {period.months} Month
                            {period.months !== 1 ? "s" : ""}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Batch *</Form.Label>
                      <Form.Select
                        name="batch"
                        value={formData.batch}
                        onChange={handleChange}
                        required
                      >
                        <option value="morning">Morning</option>
                        <option value="evening">Evening</option>
                        <option value="full_day">Full Day</option>
                        <option value="early_morning">Early Morning</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Plan Start Date *</Form.Label>
                      <DatePicker
                        selected={formData.plan_start_date}
                        onChange={handleDateChange}
                        dateFormat="yyyy-MM-dd"
                        className="form-control"
                        placeholderText="Select start date"
                      />
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Registration Fee (₹)</Form.Label>
                      <div className="input-group">
                        <span className="input-group-text">
                          <FaDollarSign />
                        </span>
                        <Form.Control
                          type="number"
                          name="registration_fee"
                          value={formData.registration_fee}
                          onChange={handleChange}
                          placeholder="500"
                          min="0"
                          step="0.01"
                        />
                      </div>
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Total Amount (₹) *</Form.Label>
                      <div className="input-group">
                        <span className="input-group-text">
                          <FaDollarSign />
                        </span>
                        <Form.Control
                          type="number"
                          name="amount"
                          value={formData.amount}
                          onChange={handleChange}
                          placeholder="3000"
                          min="1"
                          step="0.01"
                          required
                        />
                      </div>
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Paid Amount (₹)</Form.Label>
                      <div className="input-group">
                        <span className="input-group-text">
                          <FaDollarSign />
                        </span>
                        <Form.Control
                          type="number"
                          name="paid_amount"
                          value={formData.paid_amount}
                          onChange={handleChange}
                          placeholder="0"
                          min="0"
                          step="0.01"
                        />
                      </div>
                      <Form.Text className="text-muted">
                        Amount already paid by the member
                      </Form.Text>
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Plan Status</Form.Label>
                      <Form.Select
                        name="is_active"
                        value={formData.is_active}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            is_active: e.target.value === "true",
                          })
                        }
                      >
                        <option value={true}>Active</option>
                        <option value={false}>Inactive</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                </Row>

                <Form.Group className="mb-4">
                  <Form.Label>Notes (Optional)</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    name="notes"
                    value={formData.notes}
                    onChange={handleChange}
                    placeholder="Any additional notes or terms..."
                  />
                </Form.Group>

                <div className="text-center">
                  <Button
                    variant="primary"
                    type="submit"
                    disabled={saving}
                    className="me-3 px-4"
                  >
                    <FaSave className="me-2" />
                    {saving ? "Updating..." : "Update Plan"}
                  </Button>
                  <Button
                    variant="outline-secondary"
                    onClick={() => navigate("/membership/plans")}
                  >
                    Cancel
                  </Button>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </Col>

        <Col lg={4}>
          <Card className="mb-4">
            <Card.Header className="bg-info text-white">
              <h5 className="mb-0">Plan Summary</h5>
            </Card.Header>
            <Card.Body>
              <div className="plan-summary">
                {formData.member && (
                  <div className="mb-3">
                    <h6>Selected Member:</h6>
                    <p className="fw-bold">{getMemberName(formData.member)}</p>
                  </div>
                )}

                {formData.subscription_type && (
                  <div className="mb-3">
                    <h6>Subscription Type:</h6>
                    <p className="fw-bold">
                      {getSubscriptionTypeName(formData.subscription_type)}
                    </p>
                  </div>
                )}

                {formData.subscription_period && (
                  <div className="mb-3">
                    <h6>Duration:</h6>
                    <p className="fw-bold">
                      {getSubscriptionPeriodName(formData.subscription_period)}
                    </p>
                  </div>
                )}

                <div className="mb-3">
                  <h6>Batch:</h6>
                  <p className="fw-bold">
                    {formData.batch
                      ? formData.batch.charAt(0).toUpperCase() +
                        formData.batch.slice(1)
                      : "Not set"}
                  </p>
                </div>

                <div className="mb-3">
                  <h6>Start Date:</h6>
                  <p className="fw-bold">
                    {formData.plan_start_date
                      ? formData.plan_start_date.toLocaleDateString()
                      : "Not set"}
                  </p>
                </div>

                {plan.expiry_date && (
                  <div className="mb-3">
                    <h6>Expiry Date:</h6>
                    <p className="fw-bold">
                      {new Date(plan.expiry_date).toLocaleDateString()}
                    </p>
                  </div>
                )}
              </div>
            </Card.Body>
          </Card>

          <Card>
            <Card.Header className="bg-success text-white">
              <h5 className="mb-0">Payment Summary</h5>
            </Card.Header>
            <Card.Body>
              <div className="payment-summary">
                <table className="table table-sm">
                  <tbody>
                    <tr>
                      <td>Registration Fee:</td>
                      <td className="text-end">
                        ₹{formData.registration_fee || "0"}
                      </td>
                    </tr>
                    <tr>
                      <td>Plan Amount:</td>
                      <td className="text-end">₹{formData.amount || "0"}</td>
                    </tr>
                    <tr className="table-active fw-bold">
                      <td>Total Amount:</td>
                      <td className="text-end">
                        ₹{calculateTotal().toFixed(2)}
                      </td>
                    </tr>
                    <tr>
                      <td>Paid Amount:</td>
                      <td className="text-end text-success">
                        ₹{formData.paid_amount || "0"}
                      </td>
                    </tr>
                    <tr className="table-warning fw-bold">
                      <td>Pending Amount:</td>
                      <td className="text-end text-danger">
                        ₹{calculatePending().toFixed(2)}
                      </td>
                    </tr>
                    <tr>
                      <td>Fee Status:</td>
                      <td className="text-end">
                        <span
                          className={`badge ${
                            calculatePending() > 0 ? "bg-warning" : "bg-success"
                          }`}
                        >
                          {calculatePending() > 0 ? "Pending" : "Paid"}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default EditPlan;
